document.addEventListener('DOMContentLoaded', () => {
  const stickyAtc = document.querySelector('[data-sticky-atc]');
  const stickyButton = document.querySelector('[data-sticky-submit]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyVariant = document.querySelector('[data-sticky-variant]');
  const productFormWrapper = document.querySelector('product-form');
  const productForm = document.querySelector('form[data-type="add-to-cart-form"]');

  if (!stickyAtc || !stickyButton || !productFormWrapper || !productForm) return;

  const observer = new IntersectionObserver(([entry]) => {
    const show = !entry.isIntersecting;
    stickyAtc.classList.toggle('is-visible', show);
    stickyAtc.setAttribute('aria-hidden', !show);
  });

  observer.observe(productFormWrapper);

  stickyButton.addEventListener('click', () => {
    if (!stickyButton.disabled) {
      productForm.requestSubmit();
    }
  });

  const onVariantChange = (variant) => {
    if (!variant) return;

    if (stickyPrice) {
      stickyPrice.textContent = Shopify.formatMoney(
        variant.price,
        window.theme?.moneyFormat || "{{ shop.money_format }}"
      );
    }

    if (stickyVariant) {
      stickyVariant.textContent = variant.title;
    }

    stickyButton.disabled = !variant.available;
  };

  document.addEventListener('variant:change', (e) => {
    onVariantChange(e.detail?.variant);
  });

  document.addEventListener('cart:open', () => {
    stickyAtc.classList.remove('is-visible');
    stickyAtc.setAttribute('aria-hidden', 'true');
  });
});
